// app/redux/reducers/leaveRequestsReducer.js
import {
    SET_LEAVE_REQUEST_LOADING,
    CLEAR_LEAVE_REQUEST_MESSAGE,

    GET_MY_LEAVE_REQUESTS_SUCCESS,
    GET_MY_LEAVE_REQUESTS_FAIL,

    CREATE_LEAVE_REQUEST_SUCCESS,
    CREATE_LEAVE_REQUEST_FAIL,

    GET_MANAGER_INBOX_SUCCESS,
    GET_MANAGER_INBOX_FAIL,

    MANAGER_DECISION_SUCCESS,
    MANAGER_DECISION_FAIL,
    MANAGER_DELEGATE_TO_ADMIN_SUCCESS,
    MANAGER_DELEGATE_TO_ADMIN_FAIL,

    GET_MANAGER_HISTORY_SUCCESS,
    GET_MANAGER_HISTORY_FAIL,

    GET_MANAGER_TEAM_LEAVES_SUCCESS,
    GET_MANAGER_TEAM_LEAVES_FAIL,

    GET_ADMIN_INBOX_SUCCESS,
    GET_ADMIN_INBOX_FAIL,

    ADMIN_DECISION_SUCCESS,
    ADMIN_DECISION_FAIL,

    POSTPONE_LEAVE_REQUEST_SUCCESS,
    POSTPONE_LEAVE_REQUEST_FAIL,

    GET_ALL_LEAVE_REQUESTS_SUCCESS,
    GET_ALL_LEAVE_REQUESTS_FAIL,

    ADJUST_LEAVE_REQUEST_PERIOD_SUCCESS,
    ADJUST_LEAVE_REQUEST_PERIOD_FAIL,

    normalizeError,
} from "../actions/leaveRequestsActions";

const initialState = {
    loading: false,
    error: "",
    message: "",

    myRequests: [],

    managerInbox: [],
    managerHistory: [],
    teamLeaves: [],
    adminInbox: [],
    allRequests: [],
};

const toStr = (x) => normalizeError(x, "");

export default function leaveRequestsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_LEAVE_REQUEST_LOADING:
            return { ...state, loading: !!action.payload };

        case CLEAR_LEAVE_REQUEST_MESSAGE:
            return { ...state, error: "", message: "" };

        // ========= MY REQUESTS =========
        case GET_MY_LEAVE_REQUESTS_SUCCESS:
            return { ...state, myRequests: action.payload || [], error: "" };

        case GET_MY_LEAVE_REQUESTS_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= CREATE =========
        case CREATE_LEAVE_REQUEST_SUCCESS:
            return {
                ...state,
                message: "Demande envoyée avec succès",
                error: "",
            };

        case CREATE_LEAVE_REQUEST_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER INBOX =========
        case GET_MANAGER_INBOX_SUCCESS:
            return { ...state, managerInbox: action.payload || [], error: "" };

        case GET_MANAGER_INBOX_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER DECISION =========
        case MANAGER_DECISION_SUCCESS:
            return { ...state, message: "Décision envoyée", error: "" };

        case MANAGER_DECISION_FAIL:
            return { ...state, error: toStr(action.payload) };

        case MANAGER_DELEGATE_TO_ADMIN_SUCCESS:
            return { ...state, message: "Traitement transmis à l'Admin RH", error: "" };

        case MANAGER_DELEGATE_TO_ADMIN_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER HISTORY =========
        case GET_MANAGER_HISTORY_SUCCESS:
            return { ...state, managerHistory: action.payload || [], error: "" };

        case GET_MANAGER_HISTORY_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= MANAGER TEAM LEAVES =========
        case GET_MANAGER_TEAM_LEAVES_SUCCESS:
            return { ...state, teamLeaves: action.payload || [] };

        case GET_MANAGER_TEAM_LEAVES_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN INBOX =========
        case GET_ADMIN_INBOX_SUCCESS:
            return { ...state, adminInbox: action.payload || [], error: "" };

        case GET_ADMIN_INBOX_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADMIN DECISION =========
        case ADMIN_DECISION_SUCCESS:
            return { ...state, message: "Décision RH envoyée", error: "" };

        case ADMIN_DECISION_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ALL LEAVE REQUESTS (RH ADMIN) =========
        case GET_ALL_LEAVE_REQUESTS_SUCCESS:
            return { ...state, allRequests: action.payload || [], error: "" };

        case GET_ALL_LEAVE_REQUESTS_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= POSTPONE =========
        case POSTPONE_LEAVE_REQUEST_SUCCESS:
            return {
                ...state,
                message: "Demande de report envoyée",
                error: "",
            };

        case POSTPONE_LEAVE_REQUEST_FAIL:
            return { ...state, error: toStr(action.payload) };

        // ========= ADJUST =========
        case ADJUST_LEAVE_REQUEST_PERIOD_SUCCESS:
            return {
                ...state,
                message: "Période de congé ajustée avec succès",
                error: "",
            };

        case ADJUST_LEAVE_REQUEST_PERIOD_FAIL:
            return { ...state, error: toStr(action.payload) };

        default:
            return state;
    }
}
